<template>
  <div class="forgetUser">
    <div class="retrieve" v-if=!flag>
      <div class="top">{{$t('retrieveUser.forgetUser')}}</div>
      <div class="body">{{$t('retrieveUser.illustrate')}}</div>
      <el-form
        :model="demoForm"
        ref="demoForm"
        class="eb-form"
        :rules="demoRules"
        element-loading-spinner="el-icon-loading"
      >
        <!-- pn号 -->
        <el-form-item prop="pn" class="el-getcode-box">
          <span class="eb-inputwrapper" style="width:100%;margin-right:12px">
            <!-- 请输入账号下任一设备的PN -->
            <el-input 
              class="eb-input eb-preico eb-heightfull"
              style="width:100%;"
              :placeholder="$t('retrieveUser.pn')"
              v-model="demoForm.pn" 
              clearable
              maxlength="24"
              ref="loginInvitation"
            >
            </el-input>
          </span>
          <el-tooltip 
            placement="right"
            popper-class="eb-tooltip" 
          >
            <div slot="content" class="devicepn-tooltip">
              <!-- PN码 -->
            </div>
            <i class="iconfont icon-bangzhu"></i>
          </el-tooltip>
        </el-form-item>
        <!-- 错误提示 -->
        <div class="el-login-errormsg" style="color: red;padding-bottom: 20px;">
          <span>{{errorMsg}}</span>
        </div>
        <!-- 忘记账号确定 -->
        <el-form-item class="el-submit-container">
          <el-button @click="retrieveSubmit">{{$t('retrieveUser.comfig')}}</el-button>
          <el-button class="goBcak" @click="$emit('changeMode', 'login')">{{$t('retrieveUser.Return_to_login')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="account" v-if="flag">
      <div class="accountInfo">{{$t('retrieveUser.accountInfo')}}</div>
      <template v-if="userName">
        <!-- 您的用户名是 -->
        <span class="eb-font eb-fs12 eb-color-onsurface">{{$t('retrieveUser.user')}}：</span>
        <!-- 用户名大于5个字符 -->
        <div v-if="userName.length > 4" class="result row1">
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameOne}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameTwo}}</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">****</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameThree}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameFour}}</span>
            </div>
        </div>
        <!-- 用户名为4个字符 -->
        <div v-else-if="userName.length == 4" class="result row1-only3">
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameOne}}</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">*</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">*</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameTwo}}</span>
            </div>
        </div>
        <!-- 用户名为3个字符 -->
        <div v-else-if="userName.length == 3" class="result row1-only3">
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameOne}}</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">*</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameTwo}}</span>
            </div>
        </div>
        <!-- 用户名为2个字符 -->
        <div v-else class="result row1-only2">
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">*</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{userNames.userNameOne}}</span>
            </div>
        </div>
      </template>
      <!-- 手机号提示 -->
      <template v-if="phoneNum">
        <!-- 您的账号绑定的手机号码是 -->
        <span class="eb-font eb-fs12 eb-color-onsurface">{{$t('retrieveUser.phone')}}：</span>
        <div class="result row2">
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numOne}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numTwo}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numThree}}</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">****</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numFour}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numFive}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{phoneNums.numSix}}</span>
            </div>
        </div>
      </template>
      <!-- 邮箱提示 -->
      <template v-if="emailNum">
        <!-- 您的账号绑定的邮箱是 -->
        <span class="eb-font eb-fs12 eb-color-onsurface">{{$t('retrieveUser.email')}}：</span>
        <div class="result row3">
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{emailNums.emailOne}}</span>
            </div>
            <div class="result-box eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">****</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{emailNums.emailTwo}}</span>
            </div>
            <div class="result-box eb-surface11-linear eb-color-primary">
                <span class="eb-font eb-fs20 eb-fw700">{{emailNums.emailEnd}}</span>
            </div>
        </div>
      </template>  
      <el-button class="goBcak" @click="$emit('changeMode', 'login')">{{$t('retrieveUser.Return_to_login')}}</el-button>
    </div>
  </div>
</template>
<script>
import SIdentify from "@/components/identify/identify.vue";
export default {
  data() {
    return {
      errorMsg:'',
      // 表单规则
      demoRules: {
        // 设备PN码
        pn:[
          {
            required: true,
            // 请输入设备PN
            message: this.$t('retrieveUser.pleasePn'),
            trigger: "blur"
          },
          {
            pattern: /^[A-Z][\d]*$/,
            // 您输入的PN有误
            message: this.$t('retrieveUser.pnError'),
            trigger: "blur"
          }
        ],
      },
      demoForm:{
        pn:"",
      },
      flag:false,
      account:{},
      userName:'',//用户名
      phoneNum:'',//手机号
      emailNum:'',//邮箱
       //用户名提示
       userNames:{
        userNameOne:'',
        userNameTwo:'',
        userNameThree:'',
        userNameFour:'',
      },
      //手机号提示码
      phoneNums:{
        numOne:'',
        numTwo:'',
        numThree:'',
        numFour:'',
        numFive:'',
        numSix:'',
      },
      //邮箱提示
      emailNums:{
        emailOne:'',
        emailTwo:'',
        emailEnd:'',
      }
    }
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch:{
  },
  computed: {},
  props: [],
  methods: {
    retrieveSubmit(){
      this.$refs.demoForm.validate(valid=>{
        this.errorMsg=''
        if (!valid || this.isSubmitting) return false;
        this.$request.get("retrieveUsrByPnEs",{pn: this.demoForm.pn}).then(res=>{
          if (res.err==0) {
            this.flag=true
            this.userName = res.dat.usr
            this.emailNum =  res.dat.email
            this.phoneNum =  res.dat.mobile
            this.getAllNum()
          }else{
            if (res.err==257) {
              this.errorMsg=this.$t("retrieveUser.pnErrorMsg")
            }else{
              this.errorMsg=this.$t(`errCode.${res.err}`)
            }
          }
        })
      })
    },
    getAllNum(){ //截取单个提示字符串
      if(this.userName && this.userName.length == 4||this.userName.length == 3){
        this.userNames.userNameOne = this.userName.substring(0,1)
        this.userNames.userNameTwo = this.userName.substring(this.userName.length - 1,this.userName.length)
      }else if(this.userName && this.userName.length > 4){
        this.userNames.userNameOne = this.userName.substring(0,1)
        this.userNames.userNameTwo = this.userName.substring(1,2)
        this.userNames.userNameThree = this.userName.substring(this.userName.length - 2,this.userName.length - 1)
        this.userNames.userNameFour = this.userName.substring(this.userName.length - 1,this.userName.length)
      }else{
        this.userNames.userNameOne = this.userName.substring(this.userName.length - 1,this.userName.length)
      }

      if(this.phoneNum){
        this.phoneNums.numOne = this.phoneNum.substring(0,1)
        this.phoneNums.numTwo = this.phoneNum.substring(1,2)
        this.phoneNums.numThree = this.phoneNum.substring(2,3)
        this.phoneNums.numFour = this.phoneNum.substring(this.phoneNum.length - 3,this.phoneNum.length - 2)
        this.phoneNums.numFive = this.phoneNum.substring(this.phoneNum.length - 2,this.phoneNum.length - 1)
        this.phoneNums.numSix = this.phoneNum.substring(this.phoneNum.length - 1,this.phoneNum.length)
      }

      if(this.emailNum){
        this.emailNums.emailOne = this.emailNum.substring(0,1)
        this.emailNums.emailTwo = this.emailNum.substring(this.emailNum.indexOf('@')-1,this.emailNum.indexOf('@'))
        this.emailNums.emailEnd = this.emailNum.substring(this.emailNum.indexOf('@'),this.emailNum.length)
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.devicepn-tooltip{
  width: 160px;
  height: 90px;
  background: url('../../assets/img/pnMessage.png') no-repeat ;
  span{
      position: relative;
      top: -10px;
  }
}
.forgetUser {
  width: 500px;
  min-height: 350px;
  margin-top: 200px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 18px 57px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 50px;
  
  .el-getcode-box{
    /deep/.el-form-item__content{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    /deep/ .el-input__suffix {
  display: flex;
  align-items: center;
  height: 100%;
  right: 0;
}
// /deep/ .el-input__icon {
//   line-height: normal !important;
//   display: flex;
//   align-items: center;
//   height: 100%;
// }
   
  }
  /deep/.el-button{
    width: 100%;
    margin:0;
    margin-bottom:20px;
    background: #1890ff;
    color: #fff;
  }
  .goBcak{
    background: #fff;
    color: #1890ff;
  }
  .top {
    // text-align: center;
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
  }
  .body{
    padding-bottom: 20px;
  }
  .pnCode{
    display: flex;
    justify-content: flex-start;
    padding-bottom: 20px;
    align-items: center;
    /deep/.el-input{
      margin-right: 10px;
      input{
        height: 40px;
      }
    }
    .pnMessage{
    font-size:20px;
    color: #595959;
    // position: absolute;
    right: -30px;
    top: 12.5px;
    cursor: pointer;
    }
    .pnMessageYes {
    color: #1890ff;
    }
    .pnMessageNo {
    color: #595959;
    }
  }
  .messageTitle{
    // text-align: center;
    color: red;
    padding-bottom: 20px;
  }
  /deep/el-button{
    width: 100%;
  }
  .account{
    width: 100%;
        display: flex;
        flex-direction: column;
    .accountInfo{
      font-size: 30px;
      font-weight: 600;
      padding-bottom: 20px
    }
    .result{
        margin-bottom: 23.5px;
        margin-top: 6.5px;
        .result-box{
            height: 54px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
        }
    }
    .row1{
        display: grid;
        grid-gap: 6px;
        grid-template-columns: 1fr 1fr 3fr 1fr 1fr;
    }
    .row1-only2{
        display: grid;
        grid-gap: 6px;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 2fr;
    }
    .row1-only3{
        display: grid;
        grid-gap: 6px;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    }
    .row2{
        display: grid;
        grid-gap: 6px;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    }
    .row3{
        display: grid;
        grid-gap: 6px;
        grid-template-columns: 1fr 2fr 1fr 3fr;
    }
  }
  
}
</style>
<style lang="less">
@import url("../../assets/css/mixin.less");
.forgetUser {
  .el-popover.popoverPn {
    box-shadow:0px 6px 18px rgba(0,39,102, 0.6);
    padding: 4px 20px;
  }
}
</style>